import { render, staticRenderFns } from "./BonusAds.vue?vue&type=template&id=44f725ca&"
import script from "./BonusAds.vue?vue&type=script&lang=js&"
export * from "./BonusAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports